/**
 * Section Number Badge
 *
 * Circular badge displaying section number (1-based)
 */

import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface SectionNumberBadgeProps {
  /** Section number (1-based) */
  number: number;
  /** Whether section is selected */
  isSelected?: boolean;
}

export const SectionNumberBadge: React.FC<SectionNumberBadgeProps> = ({
  number,
  isSelected = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minWidth: 24,
        height: 24,
        borderRadius: '50%',
        bgcolor: isSelected
          ? theme.palette.primary.main
          : theme.palette.grey[200],
        color: isSelected
          ? theme.palette.primary.contrastText
          : theme.palette.text.secondary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 600,
        flexShrink: 0,
      }}
    >
      {number}
    </Box>
  );
};

